/**
 * Copyright 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { Box, Tabs as TabContainer } from "@nordcloud/gnui";
import { StyledTab } from "~/components/Styled/Tabs";
import { useTabStepNavigation } from "~/hooks";
import { TabCounter } from "~/views/notificationGroups/notificationGroupDetails/components/TabCounter";
import { usePlan } from "~/views/plans/PlanDetails/PlanProvider";
import { DetailsTab } from "./DetailsTab/DetailsTab";
import { GeneralNotificationsTab } from "./GeneralNotificationsTab/GeneralNotificationsTab";
import { mergePlanNotifications } from "./GeneralNotificationsTab/helpers";
import { MetadataTab } from "./MetadataTab/MetadataTab";

const TAB_STEP_MAPPING: Record<string, number> = {
  details: 0,
  metadata: 1,
  general_notifications: 2,
};

const GeneralNotificationsStyledTab = styled(StyledTab)`
  width: 16rem;
`;

export function Tabs() {
  const { currentStep, handleTab } = useTabStepNavigation(TAB_STEP_MAPPING);
  const { plan } = usePlan();
  const generalNotificationsCount = mergePlanNotifications(
    plan?.notificationGroups ?? []
  ).length;

  return (
    <Box spacing="spacing02" css={{ padding: 0 }}>
      <TabContainer step={currentStep} handleTab={handleTab}>
        <StyledTab heading="Details">
          <DetailsTab />
        </StyledTab>
        <StyledTab heading="Metadata">
          <MetadataTab />
        </StyledTab>
        <GeneralNotificationsStyledTab
          label={
            <TabCounter
              label="General Notifications"
              count={generalNotificationsCount}
            />
          }
        >
          <GeneralNotificationsTab />
        </GeneralNotificationsStyledTab>
      </TabContainer>
    </Box>
  );
}
